import ReviewList from "./ReviewList";
import ReviewShow from "./ReviewShow";
import ReviewIcon from "@mui/icons-material/StarRate";

const reviews = {
  list: ReviewList,
  show: ReviewShow,
  icon: ReviewIcon,
};

export default reviews;
